import React from 'react';
import { CellContext } from '@tanstack/react-table';
import { Endpoint } from '@hud/portal-dtos/webapp-endpoint.dto';
import { MethodsPopover } from '../MethodsPopover/MethodsPopover';


export default function methodsCellRenderer(
  cell: CellContext<Endpoint, Endpoint['methods']>,
) {
  return <MethodsPopover methods={cell.getValue()} />;
}
